import React from 'react';

/* ====================================================================
   BRANDED TROPHY SVG — matches logo trophy silhouette
   color="green" (default) | "gold" | "silver" | "bronze" | custom hex
   ==================================================================== */
const TROPHY_COLORS = {
  green:  { fill: '#4CAF50', stroke: '#1B5E20', rim: '#66BB6A', inner: '#1B5E20' },
  gold:   { fill: '#FFD700', stroke: '#B8860B', rim: '#FFEB3B', inner: '#B8860B' },
  silver: { fill: '#C0C0C0', stroke: '#757575', rim: '#E0E0E0', inner: '#757575' },
  bronze: { fill: '#CD7F32', stroke: '#8B4513', rim: '#DDA15E', inner: '#8B4513' },
  white:  { fill: '#ffffff', stroke: '#cccccc', rim: '#f5f5f5', inner: '#cccccc' },
};

function TrophySvg({ size = 16, color = 'green', style = {}, className = '' }) {
  const c = TROPHY_COLORS[color] || TROPHY_COLORS.green;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-60 -60 120 120" width={size} height={size}
      style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} className={className}>
      <path d="M-36,-48 L36,-48 C34,-44 32,-20 26,-4 C22,6 14,14 6,18 L6,28 C6,30 8,32 14,32 L16,32 L16,34 C18,34 20,36 20,38 L20,44 L-20,44 L-20,38 C-20,36 -18,34 -16,34 L-16,32 L-14,32 C-8,32 -6,30 -6,28 L-6,18 C-14,14 -22,6 -26,-4 C-32,-20 -34,-44 -36,-48 Z" fill={c.fill} stroke={c.stroke} strokeWidth="2.5"/>
      <path d="M-38,-48 C-38,-52 -34,-56 -28,-56 L28,-56 C34,-56 38,-52 38,-48 L36,-48 L-36,-48 Z" fill={c.rim} stroke={c.stroke} strokeWidth="2"/>
      <ellipse cx="0" cy="-52" rx="26" ry="5" fill={c.inner} opacity="0.4"/>
      <path d="M-34,-40 L-56,-28 L-34,0 Z" fill={c.rim} stroke={c.stroke} strokeWidth="2.5" strokeLinejoin="round"/>
      <path d="M34,-40 L56,-28 L34,0 Z" fill={c.rim} stroke={c.stroke} strokeWidth="2.5" strokeLinejoin="round"/>
      <path d="M-20,44 L20,44 L24,50 L-24,50 Z" fill={c.rim} stroke={c.stroke} strokeWidth="2"/>
      <rect x="-28" y="50" width="56" height="8" rx="3" fill={c.fill} stroke={c.stroke} strokeWidth="2"/>
    </svg>
  );
}

export { TROPHY_COLORS };
export default TrophySvg;
